import React from 'react';
import glamorous from 'glamorous';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import { Icon, IconClasses, Intent } from '@blueprintjs/core';
import { get, isEmpty, map, size } from 'lodash';

const StyledIcon = glamorous(Icon)({
  cursor: 'pointer',
  marginLeft: 10,
});

const ChartTopBar = (props) => {
  const {
    id,
    datasets,
    chartTypes,
    label,
    helpText,
    selectedDatasetId,
    selectedChartType,
    onDatasetChange,
    onChartTypeChange,
    setIsFullScreen,
  } = props;

  const showDatasets = !isEmpty(datasets) && size(datasets) > 1;
  const showChartTypes = !isEmpty(chartTypes) && size(chartTypes) > 1;
  const showTooltip = !isEmpty(helpText);

  return (
    <div className="row">
      <div className="col-md-9">
        <h3>
          {label}
        </h3>
      </div>
      <div className="col-md-3 text-right">
        {showTooltip &&
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id={id}>{helpText}</Tooltip>}
        >
          <StyledIcon
            css={{ color: '#037bc1' }}
            iconName={IconClasses.HELP}
            iconSize={Icon.SIZE_LARGE}
          />
        </OverlayTrigger>}
        <StyledIcon
          iconName={IconClasses.FULLSCREEN}
          iconSize={Icon.SIZE_LARGE}
          onClick={e => setIsFullScreen(true)}
        />
      </div>
      <div className="col-md-6">
        {showDatasets &&
        <select
          className="form-control"
          value={selectedDatasetId}
          onChange={onDatasetChange}
        >
          {map(datasets, ds => (
            <option key={ds.id} value={ds.id}>
              {ds.label}
            </option>
          ))}
        </select>}
      </div>
      <div className="col-md-6">
        {showChartTypes &&
        <select
          className="form-control"
          value={selectedChartType}
          onChange={onChartTypeChange}
        >
          {map(chartTypes, ct => (
            <option key={ct} value={ct}>
              {ct}
            </option>
          ))}
        </select>}
      </div>
    </div>
  );
};

export default ChartTopBar;



// WEBPACK FOOTER //
// ./src/views/dashboard/chart/chart-top-bar.js